var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/custom/abbrasil/spa/sso/SSO.vue?vue&type=template&id=69446e28&
// module id = 1466
// module chunks = 28